<template>
  <div class="container-fluid">
    <loading class="register-overlay" v-show="showLoader" />

    <div class="row">
      <div class="col-md-10 offset-md-1 px-5">
        <div class="jbl-otp-h-right jbl-otp-right col-12">
          <div class="text-center d-block my-5">
            <img alt="Logo Icon" class="img-fluid in-fluid-70" :src="require('@/assets/images/ib-logo.svg')" />
          </div>

          <div class="jbl-otp-heading">
            <h5 class="ib-auth-desc" style="">We Have Sent You A Code To Verify Your Phone Number <span style="color: var(--primary-color);">{{ currentMobile }}</span></h5>
          </div>
          <Timer class="ib-timer" :value="time" @timeout="timeOut()" v-if="showTimer"></Timer>
          <hr class="ib-dotted-hr" style="width:100% !important;">
          <div>
            <div class="ib-input-field">
              <label class="jbl-label-sign">Mobile OTP</label>
              <input class="ib-login-input" type="text" placeholder="Mobile OTP" v-mask="'######'" required v-model="mobileOTP"/>
            </div>
          </div>
          <div class="jbl-mx-auto" style="margin: 0 auto; text-align: center; display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <a @click="updatePhoneNumber()" class="ib-link mt-4 pt-3" style="float:right;">Update Phone</a>
            <div v-if="showResend">
              <div style="color:var(--text-color); font-family:'Avenir Book'">OR</div>
              <a @click="resendOTP()" class="ib-link" style="float:right;">Resend OTP</a>
            </div>
          </div>
          <div class="ib-action-btns">
            <button @click="cancel()" class="ib-btn-outline ib-btn-width ib-btn-hover mr-3">Cancel</button>
            <button @click="submitOtp()" class="ib-btn-primary ib-btn-width ib-btn-hover">Submit</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showUpdateMobileNumberModal">
      <transition name="modal fade">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
              <div class="modal-content">
                <div class="jbl-m-inner">
                  <div class="modal-header pb-0">
                    <h3 class="login-m-title">Update Mobile Number</h3>
                    <span class="ib-m-close" @click="closeMobileNumberModal()"></span>
                  </div>
                  <div class="modal-body">
                    <div>
                      <div class="jbl-field-sign">
                        <label class="jbl-label-sign">Mobile Number</label>
                        <input v-mask="'+92##########'" type="text" class="ib-login-input" v-model="newMobileNumber" @input="validateMobileNo($event)" placeholder="Enter Mobile Number"/>
                      </div>

                      <div v-if="errors.filter(x => x.field == 'newMobileNumber').length > 0">
                        <div class="d-block jbl-text-danger">
                          <small class="text-danger in-bottom-0">{{errors.filter(x => x.field == 'newMobileNumber')[0].message}}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer ib-m-footer">
                    <button class="ib-btn-primary ib-btn-hover mr-2" style="padding: 0.7125rem 1.5625rem !important; position: relative !important; top: 2px !important;" type="button" @click="updateMobileNumberPost()">Update</button>
                    <button type="button" class="ib-btn-outline ib-btn-hover" @click="closeMobileNumberModal()">Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import { mask } from "vue-the-mask";
  import loading from '@/components/Loading/Loading';
  import Timer from '@/components/Countdown/Timer';

  export default {
    name: 'MobileVerification',
    directives: { mask },
    components: {
      loading,
      Timer
    },
    data () {
      return {
        showLoader: false,
        showTimer: true,
        showResend: false,
        currentMobile : this.$props.mobile,
        customer_quotation_id : this.$props.quotationId,
        customer_wallet:this.$props.create_wallet,
        mobileOTP: '',
        showUpdateMobileNumberModal: false,
        newMobileNumber: '',
        errors: [],
        time: 300,
        mobileModal:this.$props.create_wallet,
      }
    },
    props: ['mobile', 'quotationId','create_wallet','renderVerifyMobileModal'],
    created () {
      const self = this;
      this.$root.$on('updateModalMobileNumber', (newNumber) => {
        self.currentMobile = newNumber;
      });
    },
    beforeDestroy() {
      this.$root.$off('updateModalMobileNumber');
    },
    methods: {
      timeOut () {
        const self = this;
        self.showResend = true;
        self.showTimer = false;
      },
      async submitOtp () {
        const self = this;
        if(self.mobileOTP == '') {
          $toast.error('Mobile OTP Is Required ', { position: 'top-right' });
          return false;
        }
        var formData = new FormData();
        formData.append('customer_quotation_id', self.customer_quotation_id);
        formData.append('m_passcode', self.mobileOTP);

        self.showLoader = true;
        self.mobileModal = false;
        self.$emit('mobileModal',self.mobileModal);
        self.$emit('mobileOTP',self.mobileOTP);
        await axios.post('customer/quotation/verify_otp', formData).then(function (response) {
          self.showLoader = false;
          if (response.data.code == 200) {
            $toast.success('OTP Verified Successfully!!!', { position: 'top-right' });
              self.$root.$emit('mobileNumberVerifiedPost');
          } else {
            $toast.error(response.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.response) {
            error.response.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      async resendOTP () {
        const self = this;
        var formData = new FormData();
        formData.append('customer_quotation_id', self.customer_quotation_id);
        formData.append('mobile_no', self.currentMobile);

        self.showLoader = true;
        await axios.post('customer/quotation/send_otp', formData).then(function (response) {
          self.showLoader = false;
          self.showResend = false;
          self.showTimer = true;
          if (response.data.code == 200) {
            self.mobileOTP = '';
            $toast.success('OTP Re-sent To Your Mobile', { position: 'top-right' });
          } else {
            $toast.error(response.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.response) {
            error.response.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      validateMobileNo (event) {
        const self = this;
        let val = event.target.value;

        if(val != "") {
          const usingSplit = val.split('');
          let issue = false;

          let i = 0;
          for (i; i < 4; i++) {
            if(usingSplit[i] === '0') {
              issue = true;
              break;
            }
          }

          if (issue) {
            event.target.value = '+92';
            self.newMobileNumber = '+92';
          }
        }
      },
      updatePhoneNumber () {
        const self = this;
        self.errors = [];
        self.newMobileNumber = '';
        self.showUpdateMobileNumberModal = true;
      },
      async updateMobileNumberPost () {
        const self = this;
        self.errors = [];

        if(self.newMobileNumber.length < 13) {
          self.errors.push({
            field: 'newMobileNumber',
            message: 'Incorrect Mobile Number'
          });
        }

        if (self.errors.length > 0) {
          return false;
        }
        self.showResend = false;
        self.showTimer = false;
        let old = self.currentMobile;
        self.currentMobile =  self.newMobileNumber;
        self.$root.$emit('updateMobileNumber', self.newMobileNumber, old);
        self.closeMobileNumberModal();
        setTimeout(function() {
          self.time = 300;
          self.showTimer = true;
        }, 100);
      },
      closeMobileNumberModal () {
        const self = this;
        self.errors = [];
        self.newMobileNumber = '';
        self.showUpdateMobileNumberModal = false;

      },
      cancel () {
        const self = this;
        self.$root.$emit('closeVerifyMobileNumberModal');
      }
    }
  }
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }
  .ib-auth-desc {
    font-family: "Avenir Book" !important;
    color: var(--sub-heading-color) !important;
    font-size: 20px;
    text-align: center;
  }
  .ib-timer{
    text-align: center;
  }
  .ib-link {
    font-weight: 500 !important;
    text-decoration: underline !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Auth/VerifyMobile.vue